import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Card } from './ui/card';
import { Search, Filter } from 'lucide-react';

const SearchFilters = ({ onUrlSubmit, isLoading, showSearchName = false }) => {
  const [url, setUrl] = useState('');
  const [searchName, setSearchName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (url.trim()) {
      if (showSearchName) {
        onUrlSubmit(url.trim(), searchName.trim() || generateSearchName(url));
      } else {
        onUrlSubmit(url.trim());
      }
    }
  };

  const generateSearchName = (url) => {
    try {
      const urlObj = new URL(url);
      const params = new URLSearchParams(urlObj.search);
      const brand = params.get('brand');
      const model = params.get('model');
      const location = urlObj.pathname.includes('casablanca') ? 'Casablanca' : 'Maroc';

      let name = 'Recherche ';
      if (brand) name += 'BMW ';
      if (model) name += model.toUpperCase() + ' ';
      name += `- ${location}`;

      return name;
    } catch {
      return `Recherche - ${new Date().toLocaleDateString('fr-FR')}`;
    }
  };

  return (
    <Card className="p-6 mb-6 bg-white border border-gray-200">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          {showSearchName ? 'Créer une nouvelle recherche' : 'Scraper d\'annonces'}
        </h2>
        <p className="text-sm text-gray-600">
          {showSearchName
            ? 'Donnez un nom à votre recherche et collez le lien (Avito.ma ou Moteur.ma) pour commencer le suivi'
            : 'Collez le lien d\'une page de voitures d\'occasion (Avito.ma ou Moteur.ma) pour extraire les dernières annonces'}
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        {showSearchName && (
          <div>
            <label htmlFor="searchName" className="block text-sm font-medium text-gray-700 mb-1">
              Nom de la recherche (optionnel)
            </label>
            <Input
              id="searchName"
              type="text"
              placeholder="Ex: BMW X5 Casablanca"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              className="w-full"
            />
            <p className="text-xs text-gray-500 mt-1">
              Si laissé vide, un nom sera généré automatiquement
            </p>
          </div>
        )}

        <div className={showSearchName ? "space-y-3" : "flex space-x-3"}>
          <div className="flex-1">
            <Input
              type="url"
              placeholder="https://www.avito.ma/... ou https://www.moteur.ma/..."
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              className="w-full"
              required
            />
          </div>
          {!showSearchName && (
            <Button
              type="submit"
              disabled={isLoading || !url.trim()}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6"
            >
              {isLoading ? (
                <div className="flex items-center">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Extraction...
                </div>
              ) : (
                <div className="flex items-center">
                  <Search className="w-4 h-4 mr-2" />
                  Extraire
                </div>
              )}
            </Button>
          )}
        </div>

        {showSearchName && (
          <Button
            type="submit"
            disabled={isLoading || !url.trim()}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white"
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Création en cours...
              </div>
            ) : (
              <div className="flex items-center justify-center">
                <Search className="w-4 h-4 mr-2" />
                Créer la recherche
              </div>
            )}
          </Button>
        )}
      </form>

      <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <div className="flex items-start justify-between">
          <div className="flex items-start flex-1">
            <Filter className="w-4 h-4 text-blue-600 mt-0.5 mr-2" />
            <div className="text-xs text-blue-700 flex-1">
              <p className="font-medium mb-1">Exemples d'URLs valides:</p>
              <code className="text-xs bg-white px-2 py-1 rounded block mb-1">
                Avito: https://www.avito.ma/fr/casablanca/voitures_d_occasion-à_vendre?brand=5
              </code>
              <code className="text-xs bg-white px-2 py-1 rounded block">
                Moteur: https://www.moteur.ma/fr/voiture/achat-voiture-occasion/recherche/?marque=bmw
              </code>
            </div>
          </div>
          <Button 
            type="button"
            variant="outline"
            size="sm"
            onClick={() => {
              setUrl('https://www.avito.ma/fr/casablanca/voitures_d_occasion-à_vendre?fuel=1&regdate=2021-2023&brand=5&model=x5,x3&brand_model=5_x5,5_x3&seller_type=0');
            }}
            className="ml-3 text-xs"
          >
            Essayer
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default SearchFilters;